import React, { useEffect } from 'react';
import "./About.css";
import Aos from 'aos';
import "aos/dist/aos.css";


function About () {
  useEffect(() => {
    Aos.init({ duration:1000});

  }, [])

    return (  
    <>

      <section className="section about" id="about" aria-label="about">
        <div className="about-container" data-aos="fade-up">

          <figure className="about-banner" data-aos="fade-up-right">

            <div className="img-holder" style={{width: "520", height: "370"}}>
              <img src={"images/about/about-image3.jpg"} style={{width: "520", height: "400"}} loading="lazy" alt="about banner"
                className="img-cover" />
            </div>

            <img src={"images/about/about-shape-2.svg"} style={{width: "371", height: "220"}} loading="lazy" alt=""
              className="shape about-shape-2" />

            <img src={"images/about/about-shape-3.png"} style={{width: "722", height: "528"}} loading="lazy" alt=""
              className="shape about-shape-3" />

          </figure>

          <div className="about-content" data-aos="fade-up-left">

            <p className="section-subtitle">About Us</p>

            <h2 className="h2 section-title" style={{color:"white", fontWeight:"300"}}>
              Over 20 Years of <span class="span">Quality Education</span> for Skill Development
            </h2>

            <p className="section-text" style={{color:"#ffffff", fontWeight:"200", fontSize:"16px", lineHeight:"1.5", textAlign:"justify", margin:"20px 0",}}>
            Welcome to our school, where we pride ourselves on offering a comprehensive and high-quality education to our students. <br />With a wide range of subjects to choose from, including English, Mathematics, Science, History, and more, we are <br />dedicated to providing a well-rounded education that will prepare our students for success in their future endeavors.<br />
            For over 20 years, our school has been dedicated to providing a superior education to our students.<br />
             With a student body of over 100,000, we have a long-standing tradition of excellence in education. <br />
             Our dedicated teachers and staff work tirelessly to ensure that each and every student <br /> receives the best possible education,
            </p>

            <button type="button" class="rounded-pill  btn border-primary" style={{alignItems:"center"}}>Read More&nbsp;
                                   <span><i class="fa-solid fa-ellipsis"></i></span>
                                   </button>

            <img src={"images/about/video-shape-2.png"} style={{width: "722", height: "528"}} loading="lazy" alt=""
              class="shape about-shape-4 shape4" />

            
          </div>

        </div>
      </section>

    </>
    );
}

export default About;